import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'
import { Separator } from 'components/common/Separator/Separator'
import withRedirect from 'components/common/hoc/withRedirect'

const LoginCreateAccountLink = ({ link: { path }, name, redirectTo }) =>
  <Fragment>
    <Separator margin="0 -16px 20px" />
    <Button data-at-loginform-createanaccount narrow secondary full onClick={ () => redirectTo(path) }>{ name }</Button>
  </Fragment>

LoginCreateAccountLink.propTypes = {
  link: PropTypes.shape({
    link: PropTypes.string,
    path: PropTypes.string
  }),
  name: PropTypes.string,
  redirectTo: PropTypes.func
}

const EnhancedLoginCreateAccountLink = withRedirect(LoginCreateAccountLink)

EnhancedLoginCreateAccountLink.type = 'LoginCreateAccountLink'

export default EnhancedLoginCreateAccountLink
